module.exports = __webpack_public_path__ + "img/icons_1.31b969ad.svg";